import React, { FC } from "react";

import { Box } from "@mui/material";

import { IComissionTabs } from "./typed";
import { Count, StyledTab, StyledTabs, Wrapper } from "./styled";

export const UserTabs: FC<IComissionTabs> = ({
  alignLeft,
  withCounter,
  variant,
  maxWidth,
  tabs,
  value,
  setValue,
  Component,
}) => {
  const normalizedValue = String(value);
  const handleChange = (_e: React.SyntheticEvent, newValue: string | number) => {
    setValue(String(newValue));
  };
  return (
    <Wrapper data-testid="UserTabs">
      <Box sx={{ maxWidth: maxWidth }}>
        <StyledTabs
          scrollButtons="auto"
          variant={variant}
          value={normalizedValue}
          onChange={handleChange}
        >
          {tabs?.map(tab => (
            <StyledTab
              key={String(tab?.id)}
              alignLeft={alignLeft}
              value={String(tab?.id)}
              label={
                <Component
                  title={tab?.labelTitle || ""}
                  subTitle={tab?.labelSubTitle || ""}
                  isActive={String(tab?.id) === normalizedValue}
                />
              }
            />
          ))}
        </StyledTabs>
      </Box>

      {withCounter && (
        <Count>
          {tabs?.findIndex(el => String(el.id) === normalizedValue) + 1}/{tabs?.length}
        </Count>
      )}
    </Wrapper>
  );
};

UserTabs.defaultProps = {
  maxWidth: "100%",
};
